import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocHeartbeatsRoute: InvariantJiraRoute = {
	name: 'eoc-heartbeats',
	path: '/jira/ops/teams/:teamId/heartbeats',
	exact: true,
};
